// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const size = {
  phone: "37.5em",
  tab_port: "56.25em",
  tab_land: "75em",
  big_desktop: "112.5em",
};
export const Theme = {
  color: {
    primary: "#f18121",
    secondary: "#0f80a4",
    secondaryrgb: "15, 128, 164",
    grey_light_1: "#f7f7f7",
    grey_light_2: "#eee",

    grey_dark: "#777",
    grey_dark_2: "#999",
    grey_dark_3: "#333",

    white: "#fff",
    black: "#000",
  },
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  breakpoint: {
    phone: `only screen and (max-width: ${size.phone})`,
    tab_port: `only screen and (max-width: ${size.tab_port})`,
    tab_land: `only screen and (max-width: ${size.tab_land})`,
    big_desktop: `only screen and (min-width: ${size.big_desktop})`,
  },
};

// const qsd = {
//   //aws_app_analytics: 'disable',
//   aws_auth_facebook: "enable",
//   aws_cloud_logic: "enable",
//   aws_cloud_logic_custom: [
//     {
//       id: "b3dpahnxc5",
//       name: "QSD-PLATFORM",
//       description: "",
//       endpoint: "https://b3dpahnxc5.execute-api.us-east-1.amazonaws.com/235689",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_E: [
//     {
//       id: "b3dpahnxc5",
//       name: "QSD-PLATFORM",
//       description: "",
//       endpoint: "https://b3dpahnxc5.execute-api.us-east-1.amazonaws.com/235689",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_name: "QSD-PLATFORM",
//   aws_cloud_logic_custom_name_E: "QSD-PLATFORM",
//   aws_cognito_identity_pool_id:
//     "us-east-1:9353bbc9-07fb-4f0c-98a8-8997413585bf",
//   aws_cognito_region: "us-east-1",
//   aws_content_delivery: "enable",
//   aws_content_delivery_bucket: "qsd-resources",
//   aws_content_delivery_bucket_region: "us-east-1",
//   aws_content_delivery_cloudfront: "enable",
//   aws_content_delivery_cloudfront_domain: "d3cb79yue9i8q3.cloudfront.net",
//   aws_facebook_app_id: "281569732265049",
//   aws_facebook_app_permissions: "public_profile",
//   aws_mandatory_sign_in: "enable",
//   //aws_mobile_analytics_app_id: 'f085468f71664440ba6153ccb1036a9a',
//   //aws_mobile_analytics_app_region: 'us-east-1',
//   //aws_project_id: '5b55d3ef-e764-4657-b5c6-c0b023e8790e',
//   //aws_project_name: 'EnhanzedRN',
//   aws_project_region: "us-east-1",
//   //aws_push_apns: 'enable',
//   //aws_push_pinpoint: 'enable',
//   aws_resource_name_prefix: "qsd-resources",
//   aws_sign_in_enabled: "enable",
//   aws_user_pools: "enable",
//   aws_user_pools_id: "us-east-1_2JYLYVl9h",
//   aws_user_pools_web_client_id: "520ilpp3444pqmlstg9rc3b5nu",
//   aws_cloud_logic_custom_endpoint:
//     "https://plot7oqibl.execute-api.us-east-1.amazonaws.com/",
//   aws_org_id: "QSD",
//   aws_org_id_E: "QSD",
//   aws_user_pools_id_E: "us-east-1_2JYLYVl9h",
//   aws_user_pools_web_client_id_E: "520ilpp3444pqmlstg9rc3b5nu",
//   //aws_mobile_analytics_app_id_E: 'f085468f71664440ba6153ccb1036a9a',
//   aws_content_delivery_cloudfront_domain_E: "d3cb79yue9i8q3.cloudfront.net",
//   aws_cognito_identity_pool_id_E:
//     "us-east-1:9353bbc9-07fb-4f0c-98a8-8997413585bf",
//   aws_cloud_logic_custom_endpoint_E:
//     "https://b3dpahnxc5.execute-api.us-east-1.amazonaws.com/235689",
//   aws_ctype: 0,
//   aws_ctype_E: 0,
//   aws_cloud_logic_custom_E1: [
//     {
//       id: "b3dpahnxc5",
//       name: "QSD-PLATFORM",
//       description: "",
//       endpoint: "https://b3dpahnxc5.execute-api.us-east-1.amazonaws.com/235689",
//       region: "us-east-1",
//     },
//   ],
//   // oauth: {
//   //   domain: 'enhanzedprod.auth.us-east-1.amazoncognito.com',
//   //   scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
//   //   redirectSignIn: 'enhanzed://',
//   //   redirectSignOut: 'enhanzed://',
//   //   responseType: 'code',
//   // },
// };

// -------------------------------------------------------------------------------------------------------------------------------------

// New instances are created from here
const learneddev = {
  //aws_app_analytics: 'disable',
  main_color_1: "#0f80a4",
  main_color_2: "#f18121",
  DOMAIN: "d2siu2h000zqjf.cloudfront.net",
  DOMAIN1: "d1if2pjtoq2sst.cloudfront.net",
  aws_auth_facebook: "enable",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "ynv4bzc5g3",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://ynv4bzc5g3.execute-api.us-east-1.amazonaws.com/LEARNED_DEV_A",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_E: [
    {
      id: "ynv4bzc5g3",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://ynv4bzc5g3.execute-api.us-east-1.amazonaws.com/LEARNED_DEV_A",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cloud_logic_custom_name_E: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:55a63979-c796-4fc3-8fc8-140fae5debf6",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-dev-learned",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2siu2h000zqjf.cloudfront.net",
  aws_facebook_app_id: "281569732265049",
  aws_facebook_app_permissions: "public_profile",
  aws_mandatory_sign_in: "enable",
  //aws_mobile_analytics_app_id: 'f085468f71664440ba6153ccb1036a9a',
  //aws_mobile_analytics_app_region: 'us-east-1',
  //aws_project_id: '5b55d3ef-e764-4657-b5c6-c0b023e8790e',
  //aws_project_name: 'EnhanzedRN',
  aws_project_region: "us-east-1",
  //aws_push_apns: 'enable',
  //aws_push_pinpoint: 'enable',
  aws_resource_name_prefix: "learned-resources",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_nJz21P8GE",
  aws_user_pools_web_client_id: "ka23jghkb687p73nesnepp691",
  aws_cloud_logic_custom_endpoint:
    "https://ynv4bzc5g3.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "LEARNED",
  aws_org_id_E: "LEARNED",
  aws_user_pools_id_E: "us-east-1_nJz21P8GE",
  aws_user_pools_web_client_id_E: "ka23jghkb687p73nesnepp691",
  //aws_mobile_analytics_app_id_E: 'f085468f71664440ba6153ccb1036a9a',
  aws_content_delivery_cloudfront_domain_E: "d2siu2h000zqjf.cloudfront.net",
  aws_cognito_identity_pool_id_E:
    "us-east-1:55a63979-c796-4fc3-8fc8-140fae5debf6",
  aws_cloud_logic_custom_endpoint_E:
    "https://ynv4bzc5g3.execute-api.us-east-1.amazonaws.com/LEARNED_DEV_A",
  aws_ctype: 0,
  aws_ctype_E: 0,
  aws_cloud_logic_custom_E1: [
    {
      id: "ynv4bzc5g3",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://ynv4bzc5g3.execute-api.us-east-1.amazonaws.com/LEARNED_DEV_A",
      region: "us-east-1",
    },
  ],
  // oauth: {
  //   domain: 'enhanzedprod.auth.us-east-1.amazoncognito.com',
  //   scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
  //   redirectSignIn: 'enhanzed://',
  //   redirectSignOut: 'enhanzed://',
  //   responseType: 'code',
  // },
};
// LearnED Prod instance
const learnedProd = {
  main_color_1: "#0f80a4",
  main_color_2: "#f18121",
  DOMAIN: "d1erhpqukc9wx5.cloudfront.net",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:e0aebaeb-5794-4946-bd55-71645255ad17",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-learned",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1erhpqukc9wx5.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_Tg6DPRzxr",
  aws_user_pools_web_client_id: "6tk4bjqsrlvh58fvt7agoc2u97",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "LEARNED",
};

// T John prod instance
const tjohn = {
  main_color_1: "#00529E",
  main_color_2: "#DA251C",
  DOMAIN: "d39amklve0smgh.cloudfront.net",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:79bc7671-28d6-4cea-93e3-5f3716135dd7",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-tjohn",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d39amklve0smgh.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_n3b7dKtWe",
  aws_user_pools_web_client_id: "3i5rmhvbr0j20fg2cg9g4ka4cd",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "TJOHN",
};

// JSS Mysore Prod instance
const jssmys = {
  main_color_1: "#2e6db1",
  main_color_2: "#e35f14",
  aws_cloud_logic: "enable",
  DOMAIN: "d329yd2lem62zp.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:e025a8e3-00cb-4df3-92d9-f4f89d8f0d83",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-learned",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d329yd2lem62zp.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_j2JhCiqOF",
  aws_user_pools_web_client_id: "1bnskq40u9b3cf5afmpatqfd9o",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "JSSAHERMYSORE",
};

// JSS Ooty Prod instance
const jssooty = {
  main_color_1: "#2e6db1",
  main_color_2: "#e35f14",
  aws_cloud_logic: "enable",
  DOMAIN: "decrt8qnl2rk0.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:c2c34952-f862-4c5c-9c10-138e9a731aae",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-learned",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "decrt8qnl2rk0.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_3xjCjaelZ",
  aws_user_pools_web_client_id: "5d2bu9k7afjj02t57cfjdgc2vn",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "JSSAHEROOTY",
};

// JSS Noida Prod instance
const jssnoida = {
  main_color_1: "#E7493A",
  main_color_2: "#3B5998",
  aws_cloud_logic: "enable",
  DOMAIN: "d2yx4k7ijlk17h.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "plot7oqibl",
      name: "JS-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "JS-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:a1f9b82c-cfb1-41a4-bd4f-36d5e5df5fca",
  aws_cognito_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2yx4k7ijlk17h.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_rTjJJrt4H",
  aws_user_pools_web_client_id: "4fah8fo1qpggec2llp6ifni26g",
  aws_cloud_logic_custom_endpoint:
    "https://plot7oqibl.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "JSSAHERNOIDA",
};

// JSS Mauritius Prod instance
const jssmauritius = {
  main_color_1: " #28166F",
  main_color_2: "#DA251C",
  aws_cloud_logic: "enable",
  DOMAIN: "d1u9w9poxvz87v.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:13b8f0f8-e357-47a3-a7ba-5cf10b82da51",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-learned",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1u9w9poxvz87v.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_qlFZqEaAn",
  aws_user_pools_web_client_id: "5k943mpk045n65214n5o8qqft7",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "JSSAHERMAURITIUS",
};

// Sarada Vilas Prod instance
const saradavilas = {
  main_color_1: "#081455",
  main_color_2: "#42B0FF",
  aws_cloud_logic: "enable",
  DOMAIN: "d2zrg5m4p3ti7g.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:c0c11eda-620c-476b-9eea-2650fd93ff1a",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-tjohn",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2zrg5m4p3ti7g.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_6LDoWFMjq",
  aws_user_pools_web_client_id: "74ekjvp8ccppnmvg9uf0jddkkm",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "SARADAVILAS",
};

// Queens Prod instance
const qsd = {
  main_color_1: "#ffb81c",
  main_color_2: "#ffb81c",
  aws_cloud_logic: "enable",
  DOMAIN: "d11cwfceogqp5g.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:baf69c07-9169-46e2-8a5c-c30358d1d9e9",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-qsd",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d11cwfceogqp5g.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_xUKZxD7ov",
  aws_user_pools_web_client_id: "2f19bc50964sgm4dk2j90v9533",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "QSD",
};

// Adichunchanagiri College Prod instance
const adigiri = {
  main_color_1: "#37306F",
  main_color_2: "#A72F2E",
  aws_cloud_logic: "enable",
  DOMAIN: "d1xut4e7fr5g4q.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:a55b3148-eea2-4948-af9e-c872ef07c6ec",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-adigiri",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1xut4e7fr5g4q.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_InP6Bn7qq",
  aws_user_pools_web_client_id: "2hamlv21afshr22eaon2ne1v1d",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "ADIGIRI",
};

// Bharathi College of Pharmacy - Mandya Prod instance
const bcop = {
  main_color_1: "#2D7FC7",
  main_color_2: "#29a22c",
  aws_cloud_logic: "enable",
  DOMAIN: "d1r9hhv4z5c728.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:eacb915e-9d35-4b21-8b70-515a9532a156",
  aws_cognito_region: "us-east-1W",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-bcop",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1r9hhv4z5c728.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_9LoN5vPM3",
  aws_user_pools_web_client_id: "20c8oi00li3q3nht0goiabld1t",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "BCOP",
};

// Abhinava Bharathi College of Pharmacy - Mandya Prod instance
const abcop = {
  main_color_1: "#48487F",
  main_color_2: "#e35f14",
  aws_cloud_logic: "enable",
  DOMAIN: "d2pe6vqauiph9.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:eacb915e-9d35-4b21-8b70-515a9532a156",
  aws_cognito_region: "us-east-1",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-abcop",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2pe6vqauiph9.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_9LoN5vPM3",
  aws_user_pools_web_client_id: "20c8oi00li3q3nht0goiabld1t",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "ABCOP",
};

// Start of SDMIT instance
const sdmit = {
  main_color_1: "#0F80A4",
  main_color_2: "#FF1949",
  platform_main_theme: "linear-gradient(#0F80A4, #0F80A4)",
  button_color_web: "#0F80A4",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "9ocpxowhe2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:9aa214be-1886-4626-b951-1996d68dbd44",
  aws_cognito_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2ofkkgvyysxcg.cloudfront.net",
  DOMAIN: "d2ofkkgvyysxcg.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_SimZ3i9M4",
  aws_user_pools_web_client_id: "6mdqh8pgff90ks5b5tlirv12kp",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "SDMIT",
};

// Start of NieIT Instance
const nieit = {
  main_color_1: "#3F4094",
  main_color_2: "#3DB166",
  platform_main_theme: "linear-gradient(#3F4094, #3F4094)",
  button_color_web: "#3F4094",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "9ocpxowhe2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:51745abf-9fcf-4b7e-a781-191aa111de9e",
  aws_cognito_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d33j0q3ff48itq.cloudfront.net",
  DOMAIN: "d33j0q3ff48itq.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_AQTorejCG",
  aws_user_pools_web_client_id: "22okkf1hvempq108vlvtedc6ck",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "NIEIT",
};

// Start of University of Kashmir instance
const UOK = {
  main_color_2: "#000",
  main_color_1: "#56405E",
  aws_cloud_logic: "enable",
  DOMAIN: "d1cy14lba025je.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:f9dedd53-5463-46d6-984c-7210ae829bb0",
  aws_cognito_region: "us-east-1W",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-bcop",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1cy14lba025je.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_ID52jgYRa",
  aws_user_pools_web_client_id: "3lm7ffn7granjkq12v0bao7dec",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "UOK",
};

// Start of RP college of pharmacy Instance
const RAJPUTANA = {
  main_color_2: "#20B876",
  main_color_1: "#20B876",
  aws_cloud_logic: "enable",
  DOMAIN: "d1c6c2kmy8kitp.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:6d8df232-447e-4a06-a2d9-9a429582cd17",
  aws_cognito_region: "us-east-1W",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-bcop",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1c6c2kmy8kitp.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_pCMnvJGtr",
  aws_user_pools_web_client_id: "3a777bn2arrjp83s7fkeu3c2t3",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "RAJPUTANA",
};

// Start of GGNK college of pharmacy
const ggnk = {
  main_color_1: "#0D2643",
  main_color_2: "#81CA00",
  aws_cloud_logic: "enable",
  DOMAIN: "d1r9hhv4z5c728.cloudfront.net",
  aws_cloud_logic_custom: [
    {
      id: "cqkcbribl2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:6d8df232-447e-4a06-a2d9-9a429582cd17",
  aws_cognito_region: "us-east-1W",
  aws_content_delivery: "enable",
  aws_content_delivery_bucket: "ed-prod-ggnk",
  aws_content_delivery_bucket_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d1r9hhv4z5c728.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_lx8BDmFna",
  aws_user_pools_web_client_id: "2ms57qd8t8td6hmep8fisu1pvp",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "GGNK",
};

// Start of ALWAR college of pharmacy
const ALWARPC = {
  main_color_1: "#2E3192",
  main_color_2: "#E9312F",
  platform_main_theme: "linear-gradient(#2E3192, #2E3192)",
  button_color_web: "#2E3192",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "9ocpxowhe2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:4df4d3de-c291-42be-b470-c1a256e9997d",
  aws_cognito_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d2ima15mtg2280.cloudfront.net",
  DOMAIN: "d2ima15mtg2280.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_F031EQRKf",
  aws_user_pools_web_client_id: "4r7j7ltcj0p6ghaafhrl40nf4p",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "ALWARPC",
};

// Start of MALLIGE college of pharmacy
const MCOP = {
  main_color_1: "#01733A",
  main_color_2: "#B12639",
  platform_main_theme: "linear-gradient(#01733A, #01733A)",
  button_color_web: "#01733A",
  aws_cloud_logic: "enable",
  aws_cloud_logic_custom: [
    {
      id: "9ocpxowhe2",
      name: "LEARNED-AUTHORING",
      description: "",
      endpoint:
        "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/LEARNED_PROD",
      region: "us-east-1",
    },
  ],
  aws_cloud_logic_custom_name: "LEARNED-AUTHORING",
  aws_cognito_identity_pool_id:
    "us-east-1:6b10f021-a77c-404b-a1af-97c50018e0d4",
  aws_cognito_region: "us-east-1",
  aws_content_delivery_cloudfront: "enable",
  aws_content_delivery_cloudfront_domain: "d3u6nec2psltji.cloudfront.net",
  DOMAIN: "d3u6nec2psltji.cloudfront.net",
  aws_mandatory_sign_in: "enable",
  aws_project_region: "us-east-1",
  aws_sign_in_enabled: "enable",
  aws_user_pools: "enable",
  aws_user_pools_id: "us-east-1_nMYgWqMZ4",
  aws_user_pools_web_client_id: "37gie7k66bc3o8d556j06reblv",
  aws_cloud_logic_custom_endpoint:
    "https://cqkcbribl2.execute-api.us-east-1.amazonaws.com/",
  aws_org_id: "MCOP",
};

export default learnedProd;
